// RFC 7807 envelope as emitted by the api's GlobalExceptionFilter.
export interface Problem {
  type: string;
  title: string;
  status: number;
  detail?: string;
  errors?: Record<string, unknown>;
}

export function isProblem(x: unknown): x is Problem {
  return (
    typeof x === "object" &&
    x !== null &&
    "title" in x &&
    "status" in x &&
    typeof (x as { title: unknown }).title === "string" &&
    typeof (x as { status: unknown }).status === "number"
  );
}

export function summariseProblem(p: Problem): string {
  const detail = p.detail ? `: ${p.detail}` : "";
  return `${p.title}${detail}`;
}
